import { useEffect, useState } from "react";
import { IExchange, marketStore } from "entities/market";
import { useStore } from "zustand";

export enum ExchangeStatus {
  Closed = "closed",
  PreMarket = "pre-market",
  Open = "open",
  PostMarket = "post-market",
  Holiday = "holiday",
  Weekend = "weekend",
}
export enum ExchangeInfo {
  closeToPre = "close_to_pre",
  closeToOpen = "close_to_open",
  preToOpenClose2 = "close_to_open_close",
  openToClose = "open_to_close",
  close2ToOpen = "close2_to_open",
  close3ToPost = "close3_to_open",
  postToClose = "post_to_close",
}
export interface ExchangeTimeFrameItem {
  from: string;
  to: string;
  type: ExchangeStatus;
  progress_percent: number;
}
export type ExchangeTimeFrame = null | {
  status: ExchangeStatus;
  point: number;
  time_frame: Array<ExchangeTimeFrameItem>;
  current_index: number;
  exchange_code: string;
  exchange_logo: string;
  exchange_name: string;
  timezone: string;
  info: ExchangeInfo;
  time_left: string;
  isActive: boolean;
};

const useExchangeTimeFrame = (ex: IExchange | any): ExchangeTimeFrame => {
  const [state, setState] = useState<ExchangeTimeFrame>(null);
  const { exchangesTimeFrames } = useStore(marketStore);

  useEffect(() => {
    if (exchangesTimeFrames && ex) {
      const exchangeTimeFrame = exchangesTimeFrames.get(ex.symbol);
      if (exchangeTimeFrame) {
        setState(exchangeTimeFrame);
      } else {
        setState(null);
      }
    }
  }, [exchangesTimeFrames, ex]);

  return state;
};

export default useExchangeTimeFrame;
